import styled from 'styled-components'
import { isMobile } from '../../../../services/breakpoints.service'

export const StyledUpdate = styled.div`
	padding: 3rem 0;

	.accordion {
		margin-top: 4rem;
	}

	.dica {
		font-size: 15px;
	}
`

export const StyledButtons = styled.div`
	display: flex;
	flex-direction: row-reverse;

	button {
		min-width: 32%;
		margin-right: 5px;
		&:last-child {
			padding-left: 1rem;
			padding-right: 1rem;
		}
	}
`

export const ContainerBenefit = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`

export const StyledInputContainer = styled.div`
	align-self: flex-start;
	margin-bottom: 3rem;
	width: 100%;
`

export const SubContainerBenefit = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 20px;

	> *:nth-child(1) {
		flex: 1;
	}

	> *:nth-child(2) {
		flex: 3;
	}
`

export const StyledSeparatorOrangeLine = styled.div`
	margin: 2rem 0 2rem 0;
	border-bottom: 1px solid #d4622f;
	line-height: 2em;
`

/**
 * @param {int} columns
 *
 */
export const getGridWith3Col = (columns) => {
	return isMobile()
		? {}
		: {
				display: 'grid',
				gridGap: '15px',
				gridTemplate: `repeat(${columns}, auto) / repeat(3, 1fr)`,
		  }
}
